import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeOpen"><Path d="M12 1.28101L3 8.64464V21.0001H10V15.0001H14V21.0001H21V8.64464L12 1.28101Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeOpen;
